import { FC, MouseEventHandler } from 'react';
import { Img } from 'react-image';
import { useFragment } from 'react-relay';
import { SxProps, Theme } from '@mui/material/styles';
import graphql from 'babel-plugin-relay/macro';

import ImageIcon from '@mui/icons-material/Image';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import Box from '@mui/material/Box';

import { STATIC_URL } from 'const';
import { MediaThumb_media$key } from '__generated__/MediaThumb_media.graphql';

type Props = {
  media: MediaThumb_media$key | null;
  onClick?: MouseEventHandler<HTMLImageElement>;
  sx?: SxProps<Theme>;
};

const MediaThumb: FC<Props> = ({ media, sx, ...rest }) => {
  const mediaData = useFragment(
    graphql`
      fragment MediaThumb_media on Media {
        type
        externalUrl(size: S120X120)
        src(size: w262)
      }
    `,
    media
  );

  return (
    <Box
      sx={[
        {
          minHeight: '125px',
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: theme => theme.shape.borderRadius,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}>
      {mediaData ? (
        <Img // TODO: @Cleanup should be using useImage hook here
          src={
            mediaData.type === 'INTERNAL'
              ? `${STATIC_URL}${mediaData.src}`
              : mediaData.externalUrl!
          }
          unloader={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                minHeight: 125,
                color: '#ddd',
                fontSize: 48,
                border: `1px solid #ddd`,
                borderRadius: theme => theme.shape.borderRadius,
              }}>
              <BrokenImageIcon fontSize="inherit" />
            </Box>
          }
          {...rest}
        />
      ) : (
        <ImageIcon fontSize="inherit" />
      )}
    </Box>
  );
};

export default MediaThumb;
